import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import Localization from '../localization'
export default class Router
{
	constructor(modules)
	{
		this.modules = modules || [];
		this.loc = new Localization();

		this.routes = [
			{
				path: '/',
				name: 'layout',
				redirect: to =>
				{
					return { name: 'interact' };
				},
				component: () => import(`/src/views/shareds/layout.vue`),
				meta: {
					requiresAuth: true,
					resourceKey: 'page.layout',

					menuConfig: {
						isVisible: true,
						isExpand: true,
						isBlank: true,
						alwaysIsExpand: true,
						iconName: 'bi-layout-wtf',
					}
				},
				children: [
					{
						name: 'interact',
						path: 'interact/:chatId?',
						component: () => import('@/views/interact/interact-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.interact',
						}
					},
					{
						name: 'toolInteract',
						path: 'tool-interact/:toolName',
						component: () => import('@/views/interact/interact-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.interact',
						}
					},
					{
						name: 'newChat',
						path: 'new-chat',
						component: () => import('@/views/interact/interact-redirect-chat.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.interact',
						}
					},

					{
						name: 'newImage',
						path: 'new-image',
						component: () => import('@/views/interact/interact-redirect-image.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.interact',
						}
					},
					{
						name: 'setting',
						path: 'setting',
						component: () => import('@/views/setting/setting-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.setting',
						}
					},

					{
						name: 'notification',
						path: 'notification',
						component: () => import('@/views/notification/notification-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.notification',
						}
					},
					{
						name: 'tools',
						path: 'tools/:toolGroupId',
						component: () => import('@/views/tools/tools-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.tools',
						}
					},

					{
						name: 'toolGroups',
						path: 'tool-groups',
						component: () => import('@/views/tool-groups/tool-groups-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.toolGroups',
						}
					},

					{
						name: 'pro',
						path: 'pro',
						component: () => import('@/views/pro/pro-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.pro',
						}
					},
					{
						name: 'history',
						path: 'history',
						component: () => import('@/views/history/history-layout.vue'),
						meta: {
							requiresAuth: false,
							resourceKey: 'page.history',
						}
					},
				],
			},
			{
				name: 'auth',
				path: '/auth',
				component: () => import('@/views/auth/auth-base.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.auth',

					menuConfig: {
						visible: false
					}
				}
			},

			{
				name: 'logout',
				path: '/logout',
				component: () => import('@/views/auth/auth-logout.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.logout',

					menuConfig: {
						visible: false
					}
				}
			},

			{
				name: 'page',
				path: '/page/:slug',
				component: () => import('@/views/page/page-dynamic.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.page',

					menuConfig: {
						visible: false
					}
				}
			},

			{
				name: 'authOidc',
				path: '/auth-oidc',
				component: () => import('@/views/auth/auth-oidc.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.auth',

					menuConfig: {
						visible: false
					}
				}
			},

			{
				name: 'notFound',
				path: '/:catchAll(.*)',
				component: () => import('@/views/not-found.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.notFound',

					menuConfig: {
						visible: false
					}
				}
			},
			{
				name: 'accessDenied',
				path: '/access-denied',
				component: () => import('@/views/access-denied.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.accessDenied',

					menuConfig: {
						visible: false
					}
				}
			},
			{
				name: 'deleteAccount',
				path: '/delete-account',
				component: () => import('@/views/delete-account.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.deleteAccount',

					menuConfig: {
						visible: false
					}
				}
			},
			{
				name: 'whatsNew',
				path: '/whats-new',
				component: () => import('@/views/whats-new.vue'),
				meta: {
					requiresAuth: false,
					resourceKey: 'page.whatsNew',

					menuConfig: {
						visible: false
					}
				}
			}
		]

		for (var i = 0; i < modules.length; i++)
		{
			for (var ii = 0; ii < modules[i].routes.length; ii++)
			{
				this.routes[0].children.push(modules[i].routes[ii])
			}
		}
	}

	create()
	{
		const router = createRouter({
			history: createWebHistory(),
			routes: this.routes
		})

		var navigationInfo = null;
		router.options.history.listen((to, from, info) =>
		{
			navigationInfo = info;
		});

		const isAskMe =
			window.location.host == 'chat.askmeai.app'

		router.beforeEach((to, from, next) =>
		{
			document.body.setAttribute('data-router-loading', '1')

			document.title =
				this.loc.fromResource(to.meta.resourceKey) + ' | ' +
				this.loc.fromResource(isAskMe ? 'global.askmeai' : 'global.hooshplus');

			if (to.matched.some(record => record.meta.requiresAuth))
			{
				const token = (store.state.client || {}).token;

				if (token == undefined)
				{
					next({
						path: "/auth",
						query: { redirect: to.fullPath }
					});

					return;
				}

				if (to.path != '/hub/person/change-password' && store.state.client.fcp)
				{
					next({
						path: "/hub/person/change-password"
					})

					return;
				}
			}

			if (to.name == 'interact')
			{
				if (navigationInfo && navigationInfo.direction === 'back')
				{
					next({
						path: "/"
					})

					navigationInfo = null;

					return;
				}
			}
			else
			{
				navigationInfo = null;
			}

			next()
		})



		router.afterEach(() =>
		{
			document.body.setAttribute('data-router-loading', '0')
		})

		router.onError((error) =>
		{
			if (/ChunkLoadError/.test(error.message))
			{
				window.location.reload();
			}
		});


		return router
	}
}
